export * from './easy-tag-input-component';
